// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "flightCard__infoIcon-3WqN4";
var _4 = "flightCard__flight-3b1pl";
var _5 = "flightCard__flightBlock-2VE1u";
var _6 = "flightCard__flightTitle-z38bf";
var _7 = "flightCard__airlineLogo-3VIqM";
var _8 = "selectedFare__link-2XFD0";
var _9 = "slider__wrp-nOgo4";
var _a = "flightCard__wrapper-1pXww";
var _b = "flightCard__footer-1FeC-";
var _c = "flightCard__flightValue-225hn";
var _d = "flightCard__airline-1tHrr";
var _e = "flightCard__airlineName-y1iH0";
var _f = "flightCard__flightName-3pxHR";
var _10 = "flightCard__amenities-2Nei8";
var _11 = "flightCard__airlineNumber-1he7X";
export { _1 as "__esModule", _2 as "mobile", _3 as "flightCard__infoIcon", _4 as "flightCard__flight", _5 as "flightCard__flightBlock", _6 as "flightCard__flightTitle", _7 as "flightCard__airlineLogo", _8 as "selectedFare__link", _9 as "slider__wrp", _a as "flightCard__wrapper", _b as "flightCard__footer", _c as "flightCard__flightValue", _d as "flightCard__airline", _e as "flightCard__airlineName", _f as "flightCard__flightName", _10 as "flightCard__amenities", _11 as "flightCard__airlineNumber" }
export default { "__esModule": _1, "mobile": _2, "flightCard__infoIcon": _3, "flightCard__flight": _4, "flightCard__flightBlock": _5, "flightCard__flightTitle": _6, "flightCard__airlineLogo": _7, "selectedFare__link": _8, "slider__wrp": _9, "flightCard__wrapper": _a, "flightCard__footer": _b, "flightCard__flightValue": _c, "flightCard__airline": _d, "flightCard__airlineName": _e, "flightCard__flightName": _f, "flightCard__amenities": _10, "flightCard__airlineNumber": _11 }
